// extracted by mini-css-extract-plugin
export default {"button":"Buttons-module__button"};